module.exports = __webpack_public_path__ + "img/lie.fb5437d3.svg";